<template>
  <Modal ref="imagePreviewModal"
         class="image-preview"
         :title="tr('common.PREVIEW')"
         :size="BootstrapVariant.XLARGE"
         :static="true"
         :no-close-on-backdrop="false"
         fluid
         hide-footer
         hide-header
         centered>
    <BImg :src="image"
          class="w-100"></BImg>
  </Modal>
</template>

<script>
  import { BImg } from 'bootstrap-vue';
  import Modal from '@common/layout/Modal.vue';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import { translator } from '~/zf/frontend/common/mixins';

  /*
    [Vue migration] Developer Note
    This component has a twin version for both Vue 2 and Vue 3 projects.
    When making changes, remember to update and test both versions.
  */
  export default {
    name: 'ImagePreviewModal',
    compatConfig: {
      MODE: 3,
      COMPONENT_FUNCTIONAL: true,
    },
    components: {
      Modal,
      BImg,
    },
    mixins: [translator],
    props: ['image'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    expose: ['show'],
    methods: {
      show() {
        this.$refs.imagePreviewModal.show();
      },
    },
  };
</script>

<style scoped>
    .image-preview :deep(.modal-dialog) {
      height: 90vh;
      overflow-y: auto;
    }
</style>
